import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-178">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-179">
            Sunday night. 11 PM. You have Research Methods class tomorrow
            morning. And you are still searching online trying to figure out how
            to explain the difference between descriptive and correlational
            research without your students falling asleep or understanding
            nothing.
            <br data-id="element-180" />
            <br data-id="element-181" />
            <span className="text-gold-light font-medium" data-id="element-182">
              It is not your fault.
            </span>{' '}
            You have been fighting for years with disorganized materials, dense
            academic theory and resources designed for university professors
            that you then have to completely rewrite just to make them work in a
            high school classroom.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-184">
            The real cost of not having the right resource:
          </h3>

          <ul className="space-y-4" data-id="element-185">
            {['Nights awake searching for ways to translate dense methodological concepts into language your students can actually understand', 'Improvised lessons because you could not find clear, ready-to-use material in time', 'Disconnected students who feel that research methodology has nothing to do with them or their future', 'Uncomfortable silences when a student asks the difference between experimental and non-experimental design and you do not have a clear answer ready', 'Weekends lost building lesson plans, activities and assessments from scratch over and over again'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-186">
                <span className="text-red-500 mt-1" data-id="element-187">🔴</span>
                <span className="text-gray-300" data-id="element-188">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-189">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-190">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-191">
              Plan your entire year today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}